module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('affiliate')))]), _vm._v(" > "), _c('span', [_vm._v(_vm._s(_vm.$t('withdrawDetails')))])]), _vm._v(" "), (_vm.records.length === 0 && !_vm.loading) ? _c('div', {
    staticClass: "no-record"
  }, [_vm._v(_vm._s(_vm.$t('noRecords')))]) : _vm._e(), _vm._v(" "), (_vm.records.length > 0) ? _c('div', {
    attrs: {
      "id": "pc-records"
    }
  }, [_c('div', {
    staticClass: "little-title"
  }, [_c('p', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('p', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.$t('amount')))]), _c('p', {
    staticClass: "account"
  }, [_vm._v(_vm._s(_vm.$t('account')))]), _vm._v(" "), _c('p', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$t('status')))])]), _vm._v(" "), _vm._l((_vm.records), function(item) {
    return _c('div', {
      staticClass: "records"
    }, [_c('p', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("createFormatTime")(item.created_at, item.created_at)))]), _vm._v(" "), _c('p', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.$t(item.currency_code)) + " " + _vm._s(item[item.currency_code]))]), _vm._v(" "), _c('p', {
      staticClass: "account"
    }, [_vm._v(_vm._s(item.payment_id))]), _vm._v(" "), _c('p', {
      staticClass: "status"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t(item.status)))])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pager-bar"
    }
  }, [_c('div', {
    staticClass: "spinner-component-box"
  }, [_c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1), _vm._v(" "), _c('pager', {
    attrs: {
      "total-page": _vm.totalPage,
      "init-page": _vm.currentPage
    },
    on: {
      "go-page": _vm.queryRecords
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5ef3b20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/withdrawDetails/withdrawDetailsPc.vue
// module id = 1381
// module chunks = 1